import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { useNavigate } from "react-router-dom";
import { Button, Grid } from "@mui/material";
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
// import Zoom from "react-medium-image-zoom";
import Switch from "@mui/material/Switch";
// import Menu from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";
// import SortIcon from "@mui/icons-material/Sort";
// import SearchIcon from "@mui/icons-material/Search";
// import MicIcon from "@mui/icons-material/Mic";

// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import AmenitiesModal from "./AmenitiesModal";
// import AllAmenities from "./AllAmenities";
// End

const label = { inputProps: { "aria-label": "Size switch demo" } };

function BookAmenitiesDetails() {
  const navigate = useNavigate();

  // For memu
  // const [anchorEl, setAnchorEl] = React.useState(null);
  // const open2 = Boolean(anchorEl);
  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };
  // const handleClose2 = () => {
  //   setAnchorEl(null);
  // };
  // End

  // For Modal
  const [open, setOpen] = React.useState(false);
  const [scroll] = React.useState("paper");

  // const handleClickOpen = (scrollType) => () => {
  //   setOpen(true);
  //   setScroll(scrollType);
  // };

  const handleClose = () => {
    setOpen(false);
  };

  const descriptionElementRef = React.useRef(null);

  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
    let amenityObj = localStorage.getItem("amenityObj");
    console.log(amenityObj);
    alert(JSON.parse(amenityObj).amenity_name);
  }, [open]);
  // End

  const addCommitee = () => {
    var element = document.getElementById("successfullAdd");
    element.classList.toggle("hideModal");
  };

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid
          container
          spacing={3}
          className="mainHeadingLine AmenitiesOuterMain"
        >
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Book Amenities</h1>
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="residentManagementTable">
              <div className="">
                <div className="bookAmiListNewInner">
                  <div className="bookAminiDetailsMain">
                    <div className="bookAminiDetailsInner">
                      <div className="bookAminiDetailsHed">
                        <h2>Club House</h2>
                        <Button
                          onClick={() => navigate("/BookAmenitiesCalender")}
                        >
                          Book Now
                        </Button>
                      </div>
                      <div className="bookAminiDetailsInnerCont">
                        <p className="contTexAmineti">
                          Lorem Ipsum is simply dummy text of the printing and
                          typesetting industry. Lorem Ipsum has been the
                          industry's standard dummy text ever since the 1500s,
                          when an unknown printer took a galley of type and
                          scrambled it to mak
                        </p>

                        <div className="visitCont1 resideNewContOut">
                          <div className="visitContLeft">
                            <p className="visitContHed">Added on: 7 Jan 2017</p>
                            <p className="visitContTime">Capacity 100</p>
                          </div>

                          <div className="resideNewCont">
                            <CreateIcon
                              className="editBt"
                              // onClick={handleClickOpen2("body")}
                              // onClick={() => navigate("/")}
                            />
                            <DeleteIcon className="deleteBt" />
                            <Switch {...label} defaultChecked size="small" />
                          </div>
                        </div>

                        <div className="visitCont2">
                          <div className="visitBottCont">
                            <p>Booking Duration:</p>
                            <b>Hourly</b>
                          </div>
                          <div className="visitBottCont">
                            <p>Access:</p>
                            <b className="paidT">Paid</b>
                          </div>
                          <div className="visitBottCont">
                            <p>Charger:</p>
                            <b>500/-</b>
                          </div>
                        </div>

                        <div className="detailsAmiImOut">
                          <img src="https://media.istockphoto.com/id/1136976095/photo/white-ceramic-tray-with-home-spa-supplies-in-home-bathroom-for-relaxing-rituals-candlelight.jpg?s=612x612&w=0&k=20&c=Mj1go6ysC24UNlQ3QOwO59U4URuv_7uaTskLhkKyfes=" />
                        </div>

                        <div className="detailsAmiImOut">
                          <img src="https://media.istockphoto.com/id/1136976095/photo/white-ceramic-tray-with-home-spa-supplies-in-home-bathroom-for-relaxing-rituals-candlelight.jpg?s=612x612&w=0&k=20&c=Mj1go6ysC24UNlQ3QOwO59U4URuv_7uaTskLhkKyfes=" />
                        </div>

                        <div className="detailsAmiImOut">
                          <img src="https://media.istockphoto.com/id/1136976095/photo/white-ceramic-tray-with-home-spa-supplies-in-home-bathroom-for-relaxing-rituals-candlelight.jpg?s=612x612&w=0&k=20&c=Mj1go6ysC24UNlQ3QOwO59U4URuv_7uaTskLhkKyfes=" />
                        </div>

                        <div className="detailsAmiImOut">
                          <img src="https://media.istockphoto.com/id/1136976095/photo/white-ceramic-tray-with-home-spa-supplies-in-home-bathroom-for-relaxing-rituals-candlelight.jpg?s=612x612&w=0&k=20&c=Mj1go6ysC24UNlQ3QOwO59U4URuv_7uaTskLhkKyfes=" />
                        </div>

                        <div className="detailsAmiImOut">
                          <img src="https://media.istockphoto.com/id/1136976095/photo/white-ceramic-tray-with-home-spa-supplies-in-home-bathroom-for-relaxing-rituals-candlelight.jpg?s=612x612&w=0&k=20&c=Mj1go6ysC24UNlQ3QOwO59U4URuv_7uaTskLhkKyfes=" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>

      <div className="modalMain">
        {/* <Button onClick={handleClickOpen("paper")}>scroll=paper</Button>
      <Button onClick={handleClickOpen("body")}>scroll=body</Button> */}
        <Dialog
          open={open}
          // onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Add Amenity</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <AmenitiesModal />
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}

export default BookAmenitiesDetails;
